class EnquiryPanel extends Panel {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.wishlistWrapper = this.querySelector('[data-wishlist-wrapper]');
    this.wishlistHiddenInput = this.querySelector('[data-wishlist-hidden-input]');
    this.includeWishlistCheckbox = this.querySelector('#send-wishlist');
    this.productContainer = this.querySelector('[data-product-wrapper]');
  }

  connectedCallback() {
    this.attachWishlistData();
    this.checkForSuccess();
    if (this.wishlistHiddenInput) {
      this.includeWishlistCheckbox.addEventListener('change', this.toggleWishlistInclusion.bind(this));
    }
  }

  enableProductDetails(details) {
    this.productContainer.classList.remove('hidden');
    this.productContainer.setAttribute('aria-hidden', false);
    const titleInput = this.querySelector('[name="contact[product_title]"]');
    const priceInput = this.querySelector('[name="contact[product_price]"]');
    titleInput && (titleInput.disabled = false);
    priceInput && (priceInput.disabled = false);

    const imgTag = this.productContainer.querySelector('[data-product-img]');
    const titleTag = this.productContainer.querySelector('[data-product-title]');
    const priceTag = this.productContainer.querySelector('[data-product-price]');
    imgTag && (imgTag.src = details.image) && (imgTag.alt = details.title);
    titleTag.innerHTML = details.title;
    priceTag.innerHTML = details.price;
  }

  disableProductDetails() {
    this.productContainer.classList.add('hidden');
    const titleInput = this.querySelector('[name="contact[product_title]"]');
    const priceInput = this.querySelector('[name="contact[product_price]"]');
    titleInput && (titleInput.disabled = true);
    priceInput && (priceInput.disabled = true);
  }

  async attachWishlistData() {
    if (this.dataset.wishlist !== 'true') {
      return;
    }
    const id = localStorage.getItem('wk_session_id');
    if (!id) {
      return;
    }

    const response = await this.getWishlistData(id);
    if (!response) {
      console.error('No response from getWishlistData');
      return;
    }

    const data = await response.text();
    const responseJson = JSON.parse(data);
    if (!responseJson.wishlist || !responseJson.wishlist.items) {
      console.error('Invalid wishlist data');
      return;
    }

    // Extract 'id' from each item
    const productIds = responseJson.wishlist.items.map((item) => `id:${item.productId}`);
    if (!productIds.length) {
      return;
    }

    // Fetch product data
    const searchProductDataResponse = await this.searchProductData(productIds);

    // Parse the HTML response
    const html = new DOMParser().parseFromString(searchProductDataResponse, 'text/html');
    const shopifySection = html.querySelector('.shopify-section');
    if (!shopifySection) {
      console.error('No .shopify-section found in the response');
      return;
    }

    const returnString = shopifySection.innerHTML;

    // Update the DOM elements
    this.wishlistWrapper.classList.remove('hidden');
    this.wishlistHiddenInput.value = returnString;
    this.wishlistHiddenInput.disabled = false;
  }

  async getWishlistData(id) {
    return fetch('https://api.appmate.io/v2/wishlists/mine', {
      headers: {
        'Content-Type': 'application/json',
        'x-appmate-shp': 'jessicamccormack.myshopify.com',
        'x-appmate-sid': id,
        'x-appmate-src': 'wishlist',
        'x-appmate-vca': 'true',
        'x-appmate-vcm': 'true',
      },
    });
  }

  async searchProductData(productIds) {
    const q = productIds.join(' OR ');
    const url = `/search?section_id=search-data&type=product&q=${encodeURIComponent(q)}`;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      return await response.text();
    } catch (error) {
      console.error('Error fetching product data:', error);
      throw error;
    }
  }

  toggleWishlistInclusion({ target: { checked } }) {
    this.wishlistHiddenInput.disabled = !checked;
  }

  checkForSuccess() {
    const params = new URLSearchParams(window.location.search);

    if (params.get('contact_posted') === 'true') {
      panelManager.dispatch('OPEN_ENQUIRY_INSTANT');
    }
  }

  transitionFrom(previousState, newState, triggerElement, previousPanel) {
    // super.transitionFrom(previousState, newState, triggerElement, previousPanel);
    this.activate();
    requestAnimationFrame(() => {
      if (previousState === 'idle') {
        actions.openRightFullNav().then(() => {
          window.trapFocus(this, this.defaultFocus, triggerElement);
        });
      } else if (previousState === 'enquirySubmission') {
        // un-hide mask
        maskElement.classList.replace('opacity-0', 'opacity-60');
        maskElement.show();
        // un-hide drawer
        drawerWrapperElement.style.zIndex = '100';
        drawerWrapperElement.classList.remove('hidden');
        drawerElement.className =
          'drawer-inner transition-all absolute inset-y-0 z-75 w-full ' + 'md:right-0 bg-white duration-600 md:w-25';
        drawerElement.addEventListener('mouseover', mouseOverDrawer);
        window.trapFocus(this, this.defaultFocus, triggerElement);
      } else if (previousState === 'contactActive') {
        window.trapFocus(this, this.defaultFocus, triggerElement);
        if (previousPanel) {
          previousPanel.deactivate();
        }
      }
    });

    this.attachWishlistData();
    if (triggerElement && triggerElement.dataset.enquireProduct) {
      this.enableProductDetails(JSON.parse(triggerElement.dataset.enquireProduct));
    } else {
      this.disableProductDetails();
    }
  }
}
customElements.define('enquiry-panel', EnquiryPanel);
